const KEY      = 'localEmployeeWarnings';
const SENT_KEY = 'sentEmployeeWarnings';

function readAll(key = KEY) {
  try {
    const raw = localStorage.getItem(key);
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch (_) {
    return [];
  }
}

function writeAll(items, key = KEY) {
  localStorage.setItem(key, JSON.stringify(items));
}

export default function warningsLocalService() {
  return {
    list() {
      return readAll(KEY);
    },
    add(entity) {
      const items = readAll(KEY);
      const item = {
        ...entity,
        Id: `local-${Date.now()}`,
        _local: true,
      };
      items.unshift(item);
      writeAll(items, KEY);
      return item;
    },
    remove(id) {
      const items = readAll(KEY).filter((it) => (it?.Id ?? it?.id) !== id);
      writeAll(items, KEY);
    },
    update(id, changes = {}) {
      const updated = readAll(KEY).map((it) => {
        if ((it?.Id ?? it?.id) !== id) return it;
        return { ...it, ...changes };
      });
      writeAll(updated, KEY);
    },
    clear() {
      writeAll([], KEY);
    },

    // ── Sent history (permanent log, never synced) ──────────────────────────
    listSent() {
      return readAll(SENT_KEY);
    },
    addSent(entity) {
      const items = readAll(SENT_KEY);
      const id = entity?.Id ?? entity?.id;
      const alreadyExists = id && items.some((it) => (it?.Id ?? it?.id) === id);
      if (alreadyExists) return;
      const item = {
        ...entity,
        Id: entity.Id || `sent-${Date.now()}`,
        _local: true,
        _sent: true,
        syncedToDb: true,
      };
      items.unshift(item);
      writeAll(items, SENT_KEY);
      return item;
    },
    removeSent(id) {
      const items = readAll(SENT_KEY).filter((it) => (it?.Id ?? it?.id) !== id);
      writeAll(items, SENT_KEY);
    },
    clearSent() {
      writeAll([], SENT_KEY);
    },
  };
}
